import { render, staticRenderFns } from "./XmlSubGroupImage.vue?vue&type=template&id=2c4495a4&scoped=true"
import script from "./XmlSubGroupImage.vue?vue&type=script&lang=js"
export * from "./XmlSubGroupImage.vue?vue&type=script&lang=js"
import style0 from "./XmlSubGroupImage.vue?vue&type=style&index=0&id=2c4495a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4495a4",
  null
  
)

export default component.exports